import React from "react";
import { ProfileManagerComponent } from "features/Profile/index";

function Profile(props) {
  return <ProfileManagerComponent />;
}

export default Profile;
